<template>
  <div>
    <div class=" overflow-hidden">
      <div class="relative mt-4">
        <h3
          class="text-center text-3xl leading-8 text-darkpurple font-bebas tracking-wide text-gray-900 sm:text-4xl sm:leading-10"
        >
          User Group Meeting Extras Pack
        </h3>
        <p
          class="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-gray-900 font-semibold"
        >
          We've bundled together clipart, project files, and vectors for you to
          get even more out of our first ever online user group meeting!
        </p>
      </div>
      <div class="mt-10">
        <div class="">
          <div class="bg-vlight-paper rounded-lg  overflow-hidden shadow-xl">
            <div
              class="mt-10 p-4 flex flex-row flex-wrap justify-around
           "
            >
              <!-- clipart -->
              <div class="md:w-1/3  px-2">
                <!--                <div-->
                <!--                  class="flex items-center justify-center h-10 w-10 rounded-full-->
                <!--                text-green border-2 border-green mx-auto"-->
                <!--                >-->
                <!--                  <svg-->
                <!--                    class="w-6 h-6"-->
                <!--                    fill="none"-->
                <!--                    stroke="currentColor"-->
                <!--                    viewBox="0 0 24 24"-->
                <!--                    xmlns="http://www.w3.org/2000/svg"-->
                <!--                  >-->
                <!--                    <path-->
                <!--                      stroke-linecap="round"-->
                <!--                      stroke-linejoin="round"-->
                <!--                      stroke-width="2"-->
                <!--                      d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"-->
                <!--                    ></path>-->
                <!--                  </svg>-->
                <!--                </div>-->
                <div class="mt-4">
                  <h4
                    class="text-lg leading-6 font-semibold text-gray-900 text-center"
                  >
                    D&amp;M Clipart
                  </h4>
                  <div class="rounded mt-2">
                    <img
                      src="/images/Shop_Banner_D&M_Clipart.jpg"
                      alt=""
                      class="rounded"
                    />
                  </div>
                  <p class="mt-2 text-base leading-6 text-gray-900">
                    We have included $180US worth of Design & Make clipart with
                    this years User Group Meeting purchase bundle. There are 18
                    pieces altogether made up of 6 different models, each in all
                    three of the usual D&M styles.
                  </p>
                </div>
              </div>

              <!-- gadgets -->
              <div class="md:w-1/3 px-2">
                <!--                <div-->
                <!--                  class="flex items-center justify-center h-10 w-10 rounded-full-->
                <!--                text-green border-2 border-green mx-auto"-->
                <!--                >-->
                <!--                  <svg-->
                <!--                    class="w-6 h-6"-->
                <!--                    fill="none"-->
                <!--                    stroke="currentColor"-->
                <!--                    viewBox="0 0 24 24"-->
                <!--                    xmlns="http://www.w3.org/2000/svg"-->
                <!--                  >-->
                <!--                    <path-->
                <!--                      stroke-linecap="round"-->
                <!--                      stroke-linejoin="round"-->
                <!--                      stroke-width="2"-->
                <!--                      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"-->
                <!--                    ></path>-->
                <!--                  </svg>-->
                <!--                </div>-->
                <div class="mt-4">
                  <h4
                    class="text-lg leading-6 font-semibold text-gray-900 text-center"
                  >
                    Gadgets
                  </h4>
                  <div class="rounded mt-2">
                    <img
                      src="/images/Shop_Banner_Gadgets.jpg"
                      alt=""
                      class="rounded"
                    />
                  </div>
                  <p class="mt-2 text-base leading-6 text-gray-900">
                    You will receive the complete gadget created in

                    <router-link
                      to="/session/create-your-own-gadgets"
                      class="text-darkpurple underline"
                    >
                      Mike's Session
                    </router-link>
                    on creating your own gadgets. In addition you receive a
                    bonus video in which Mike will walk you through creating
                    your own user interface for a gadget.
                  </p>
                </div>
              </div>

              <div class="md:w-1/3  px-2">
                <!--                <div-->
                <!--                  class="flex items-center justify-center h-10 w-10 rounded-full-->
                <!--                text-green border-2 border-green mx-auto"-->
                <!--                >-->
                <!--                  <svg-->
                <!--                    class="w-6 h-6"-->
                <!--                    fill="none"-->
                <!--                    stroke="currentColor"-->
                <!--                    viewBox="0 0 24 24"-->
                <!--                    xmlns="http://www.w3.org/2000/svg"-->
                <!--                  >-->
                <!--                    <path-->
                <!--                      stroke-linecap="round"-->
                <!--                      stroke-linejoin="round"-->
                <!--                      stroke-width="2"-->
                <!--                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"-->
                <!--                    ></path>-->
                <!--                  </svg>-->
                <!--                </div>-->
                <div class="mt-4">
                  <h4
                    class="text-lg leading-6 font-semibold text-gray-900 text-center"
                  >
                    2D Vectors
                  </h4>
                  <div class="rounded mt-2">
                    <img
                      src="/images/Shop_Banner_Vectors.jpg"
                      alt=""
                      class="rounded"
                    />
                  </div>
                  <p class="mt-2 text-base leading-6 text-gray-900">
                    We have included Beki's collection of 20 2D vector designs
                    some of which are shown above.
                  </p>
                </div>
              </div>

              <!-- project files -->
              <div class="md:w-1/3 md:mt-10">
                <!--                <div-->
                <!--                  class="flex items-center justify-center h-10 w-10 rounded-full-->
                <!--                text-green border-2 border-green mx-auto"-->
                <!--                >-->
                <!--                  <svg-->
                <!--                    class="w-6 h-6"-->
                <!--                    fill="none"-->
                <!--                    stroke="currentColor"-->
                <!--                    viewBox="0 0 24 24"-->
                <!--                    xmlns="http://www.w3.org/2000/svg"-->
                <!--                  >-->
                <!--                    <path-->
                <!--                      stroke-linecap="round"-->
                <!--                      stroke-linejoin="round"-->
                <!--                      stroke-width="2"-->
                <!--                      d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"-->
                <!--                    ></path>-->
                <!--                  </svg>-->
                <!--                </div>-->
                <div class="mt-4">
                  <h4
                    class="text-lg leading-6 font-semibold text-gray-900 text-center"
                  >
                    Vectric Project Files
                  </h4>
                  <div class="rounded mt-2">
                    <img
                      src="/images/Shop_Banner_Vectric.jpg"
                      alt=""
                      class="rounded"
                    />
                  </div>
                  <p class="mt-2 text-base leading-6 text-gray-900">
                    We have included the following project files from the
                    Vectric sessions
                  </p>
                  <ul class="list-disc list-inside mt-1 leading-7">
                    <li>
                      <router-link
                        to="/session/zoo-topia-slot-together-animal-furniture"
                        class="text-darkpurple underline"
                      >
                        Slot Together 2D Giraffe
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/zoo-topia-slot-together-animal-furniture"
                        class="text-darkpurple underline"
                      >
                        Slot Together 2D Rhino with a bonus video and file for
                        adding shelves
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/3d-modelling-gorilla-s-head"
                        class="text-darkpurple underline"
                      >
                        Fully Sliced 3D Gorilla Model
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/repeating-mouldings"
                        class="text-darkpurple underline"
                      >
                        Adam's repeating Molding panel
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/hybrid-laser"
                        class="text-darkpurple underline"
                      >
                        3 X Laser Files
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/quote-portraits"
                        class="text-darkpurple underline"
                      >
                        In depth Photo VCarving Files
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/whats-new-in-version-10-5"
                        class="text-darkpurple underline"
                      >
                        What's New in V10 Sign and Hybrid CNC /Laser Face files
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/efficient-custom-projects"
                        class="text-darkpurple underline"
                      >
                        Efficient custom project files 4 x Custom Signs and 5 x
                        Template Files
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Partner Projects -->
              <div class="md:w-1/3 md:mt-10">
                <!--                <div-->
                <!--                  class="flex items-center justify-center h-10 w-10 rounded-full-->
                <!--                text-green border-2 border-green mx-auto"-->
                <!--                >-->
                <!--                  <svg-->
                <!--                    class="w-6 h-6"-->
                <!--                    fill="none"-->
                <!--                    stroke="currentColor"-->
                <!--                    viewBox="0 0 24 24"-->
                <!--                    xmlns="http://www.w3.org/2000/svg"-->
                <!--                  >-->
                <!--                    <path-->
                <!--                      stroke-linecap="round"-->
                <!--                      stroke-linejoin="round"-->
                <!--                      stroke-width="2"-->
                <!--                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"-->
                <!--                    ></path>-->
                <!--                  </svg>-->
                <!--                </div>-->
                <div class="mt-4">
                  <h4
                    class="text-lg leading-6 font-semibold text-gray-900 text-center"
                  >
                    Partner Projects
                  </h4>
                  <div class="rounded mt-2">
                    <img
                      src="/images/Shop_Banner_PartnerProjects.jpg"
                      alt=""
                      class="rounded"
                    />
                  </div>
                  <p class="mt-2 text-base leading-6 text-gray-900">
                    Get the following files from the following partner projects
                    including;
                  </p>
                  <ul class="list-disc list-inside mt-1 leading-7">
                    <li>
                      <router-link
                        to="/session/creating-a-toy-truck"
                        class="text-darkpurple underline"
                      >
                        Tim Sway's Toy Truck
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/textured-and-fluted-bowls"
                        class="text-darkpurple underline"
                      >
                        Randy Johnson's Textured and fluted Bowls
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/tools-today"
                        class="text-darkpurple underline"
                      >
                        Matt Plumlee's sign files
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/rainfall-projects"
                        class="text-darkpurple underline"
                      >
                        Rainfall Projects - Hurley
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/rainfall-projects"
                        class="text-darkpurple underline"
                      >
                        Rainfall Projects - Sword
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        to="/session/rainfall-projects"
                        class="text-darkpurple underline"
                      >
                        Rainfall Projects - Large Bowl
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- 2D Vectors -->
            </div>
            <div v-if="onSale || isAdmin">
              <div
                class=" p-4 border-t border-green"
                v-if="hasFreeBundle == false"
              >
                <p class="text-lg text-gray-900 text-center">
                  All the included project files, 3D clipart, gadgets & more are
                  now available to be purchased for
                  <span
                    class="font-bold text-darkpurple"
                    v-bind:data-fsc-item-path="productPath"
                    data-fsc-item-price="price"
                  ></span>
                </p>
                <p class="text-lg text-gray-900 text-center mt-2">
                  <span class="font-semibold">Note:</span> All project files require a minimum version of 10.5 of the software.
                </p>
                <div class="flex justify-center mt-6">
                  <button
                    v-if="loggedIn"
                    class="items-center justify-center px-5 py-3 border border-transparent text-xl font-bebas tracking-wider
                 leading-6 font-medium rounded-md text-white bg-darkpurple hover:bg-peach
                transition duration-150 ease-in-out"
                    @click="purchase"
                  >
                    Buy Now
                  </button>
                </div>
              </div>
              <div
                class="p-4 border-t border-green text-lg text-gray-900 text-center"
                v-if="hasFreeBundle"
              >
                <p>
                  Great news! You got the bundle for FREE
                </p>
                <p>
                  You can download it by accessing your
                  <a
                    href="https://portal.vectric.com/"
                    target="_blank"
                    class="font-bold hover:underline"
                  >
                    V&amp;Co</a
                  >
                  account
                </p>
              </div>
            </div>
            <div v-else class="border-t border-green p-6">
              <p class="text-lg text-gray-900 text-center font-semibold">
                The user group meeting bundle will be available to buy when the
                event begins
              </p>
            </div>
          </div>
          <login-in-to-join-in
            v-if="!loggedIn"
            message="Log in to Purchase "
          ></login-in-to-join-in>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

import {auth, freeBundlesCollection} from "../utils/firebase"
import LoginInToJoinIn from "../components/LoginInToJoinIn";
import {mapGetters} from "vuex";
import { sanityClient } from "../utils/sanity";

export default {
  name: "Purchase",
  components: {LoginInToJoinIn},
  data() {
    return {
      productPath: "vectric-user-group-bundle",
      hasFreeBundle: false,
      onSale: false,
    };
  },
  mounted() {
    this.initializeFS();
    this.checkFreeBundle();
  },
  updated() {
    this.checkFreeBundle();
  },
  created() {
    // Fetch the purchase settings
    sanityClient.getDocument("siteSettings").then(res => {
      this.onSale = res.bundleOnSale
      }
    ).catch(err => console.error(err))
  },
  computed: {
    ...mapGetters(['loggedIn', 'isAdmin'])
  },
  methods: {
    checkFreeBundle() {
      if (this.loggedIn && !this.hasFreeBundle) {
        const self = this;
        freeBundlesCollection
          .where("email", "==", auth.currentUser.email)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(function (doc) {
              if (doc.data().email === auth.currentUser.email) {
                self.hasFreeBundle = true;
              }
            })
          })
      }
    },
    initializeFS() {
      let customerDetails = {
        "reset": true,
        "tags": {
          route: "onlineUserGroupMeeting"
        }
      };

      // eslint-disable-next-line no-undef
      fastspring.builder.push(customerDetails);
    },
    purchase() {
      // eslint-disable-next-line no-undef
      fastspring.builder.push({

        "paymentContact": {
          "email": this.$store.state.user.email,
        },
      });
      // eslint-disable-next-line no-undef
      fastspring.builder.add(this.productPath);
      // eslint-disable-next-line no-undef
      fastspring.builder.checkout();
    },
  },

};
</script>
